// Report flow item sistem aktivitesi — comment feed'e benzer sekilde
// gosterilen otomatik audit trail. Trigger yazar, UI okur.

// item_id ve column ids: report_flow_items.id serial (integer). from_value /
// to_value tabloda TEXT (activity turleri karisik value tipi tutabilsin);
// column lookup icin integer'a cast edilir hook tarafinda.
export const GET_REPORT_FLOW_ITEM_ACTIVITIES = `
  query GetReportFlowItemActivities($itemId: Int!) {
    report_flow_item_activities(
      where: { item_id: { _eq: $itemId } }
      order_by: { occurred_at: asc }
    ) {
      id
      activity_type
      from_value
      to_value
      occurred_at
      actor {
        id
        first_name
        last_name
      }
    }
  }
`;

// report_flow_columns.column_title (name DEGIL) — daha once "name" yazip
// lookup bos donuyordu → feed "126 → 127" gibi cikiyor id gorunuyordu.
export const GET_REPORT_FLOW_COLUMN_NAMES = `
  query GetReportFlowColumnNames($ids: [Int!]!) {
    report_flow_columns(where: { id: { _in: $ids } }) {
      id
      column_title
    }
  }
`;
